import React from 'react';
import { useDispatch } from 'react-redux';
import { getQueryStringValues } from '../../utils/withPath';
import { Button, Text } from '../../components/element';
import { resetTechDocAction } from '../../actions';
import { PRODUCT_ID_DHCI, PRODUCT_ID_OAAS, STORAGE_PURCHASE_OPT_OWNED, MODEL_ALLETRAMPX10000 } from '../../constants';
import { trackProductSelect } from '../../utils/eventTracker';
const navigate = props => {
  // Need To: Update the URL as per selected product
  let url = '/getting-started/select-model';
  const product = props.id;
  const qsValues = getQueryStringValues(props.location);
  const model = qsValues['model'];
  let qsString = `product=${product}`;
  qsString += model ? `&model=${model}` : '';
  switch (product) {
    case PRODUCT_ID_DHCI: {
      const opt = qsValues['opt'];
      qsString += opt ? `&opt=${opt}` : '';
      break;
    }
    case PRODUCT_ID_OAAS: {
      qsString = `product=${product}&storagepurchaseopt=${STORAGE_PURCHASE_OPT_OWNED}`;
      qsString += `&model=${MODEL_ALLETRAMPX10000}`;
      break;
    }
    default:
      break;
  }
  props.history.push(`${url}?${qsString}`);
};

const ProductItem = props => {
  const dispatch = useDispatch();
  return (
    <Button
      data-test-id={`product-item-${props.id}`}
      onClick={() => {
        resetTechDocAction(dispatch);
        trackProductSelect(props.id);
        navigate(props);
      }}
      style={{ width: '275px', marginTop: '10px', height: '60px' }}
      label={
        <Text className="fontSize18" weight="bold" style={{ color: 'white' }}>
          {props.value}
        </Text>
      }
    />
  );
};

const ProductsList = props => {
  const products = props.products;
  const productItems = products.map(product => (
    <ProductItem
      id={product.id}
      key={product.id}
      value={product.value}
      location={props.location}
      history={props.history}
      data-test-id="product-main-select"
    />
  ));
  return <React.Fragment>{productItems}</React.Fragment>;
};

export default ProductsList;
